import defaultLocale from './default';
export default defaultLocale;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/locale/en_US.js
// module id = 469
// module chunks = 0